module.exports = __webpack_public_path__ + "static/img/03.7c3bcbe3.png";